// src/components/session/LogoutControl.tsx
import React from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSession } from '../../contexts/SessionContext';
import useLogout from '../../hooks/useLogout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons';

const LogoutControl: React.FC = () => {
  const { t } = useTranslation();
  const { sessionState, dispatch } = useSession();
  const { logout, error } = useLogout();

  const handleLogout = async () => {
    const success = await logout(sessionState.account);
    if (success) {
      dispatch({ type: 'LOGOUT' });
    } else if (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <Button type="button" variant="" className='button-logout text-danger gap-2' onClick={handleLogout}>
      {t('logout')}
      <FontAwesomeIcon icon={faArrowRightFromBracket}/>
    </Button>
  );
};

export default LogoutControl;
